import type { QueryClient } from "@tanstack/react-query";

/** React-query key prefixes for GET /main-card/:id used in deck / feed previews. */
export const DECK_MAIN_CARD_BY_ID_QUERY_KEYS = ["main-card-by-id", "my-feed-card-by-id"] as const;

/**
 * Refetch active card-by-id queries after talent adds a page so book-view
 * previews (OwnedDeckCardList, MyFeed, etc.) update without closing the modal.
 */
export function invalidateDeckMainCardByIdQueries(
  queryClient: QueryClient,
  cardId?: number | string | null
) {
  const normalizedId = cardId != null && String(cardId).length > 0 ? String(cardId) : null;

  DECK_MAIN_CARD_BY_ID_QUERY_KEYS.forEach((headKey) => {
    queryClient.invalidateQueries({
      predicate: (query) => {
        const [head, second] = query.queryKey as unknown[];
        if (head !== headKey) return false;
        if (!normalizedId) return true;
        return String(second) === normalizedId;
      },
    });
  });
}
